import React, { createContext, useState, useContext, useEffect } from 'react';
import API from '../api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const usuarioGuardado = localStorage.getItem('usuario');
    if (usuarioGuardado) {
      setUsuario(JSON.parse(usuarioGuardado));
    }
    setCargando(false);
  }, []);

  const login = async (usuarioInput, clave) => {
    const response = await API.post('/auth/login', { usuario: usuarioInput, clave });
    if (response.data.status === 'success') {
      setUsuario(response.data.usuario);
      localStorage.setItem('usuario', JSON.stringify(response.data.usuario));
      return true;
    }
    return false;
  };

  const logout = async () => {
    try {
      const u = JSON.parse(localStorage.getItem('usuario') || 'null');
      if (u?.token) {
        await API.post('/auth/logout', {}, { headers: { 'x-session-token': u.token } });
      }
    } catch (e) {
      /* best-effort */
    }
    setUsuario(null);
    localStorage.removeItem('usuario');
  };

  const isAdmin = () => usuario?.rol === 'admin' || usuario?.es_super_admin === true;
  const isSuperAdmin = () => usuario?.es_super_admin === true;
  const isSupervisor = () => usuario?.rol === 'supervisor';
  const isAsesor = () => usuario?.rol === 'asesor';
  const isDelivery = () => usuario?.rol === 'delivery';
  const isReadOnly = () => usuario?.rol === 'supervisor';

  const getRolLabel = () => {
    const labels = {
      admin: 'Admin',
      supervisor: 'Supervisor',
      asesor: 'Asesor',
      delivery: 'Delivery',
    };
    return labels[usuario?.rol] || 'Asesor';
  };

  const getSedeInfo = () => {
    if (!usuario?.codigo_sede) return null;
    return {
      codigo: usuario.codigo_sede,
      nombre: usuario.sede_nombre || usuario.codigo_sede,
    };
  };

  return (
    <AuthContext.Provider
      value={{
        usuario,
        cargando,
        login,
        logout,
        isAdmin,
        isSuperAdmin,
        isSupervisor,
        isAsesor,
        isDelivery,
        isReadOnly,
        getRolLabel,
        getSedeInfo,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
